// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e76d99f8","349":"01333cba","455":"ad8cc871"}[chunkId] + ".chunk.js";
};